<template>
    <div class="projects-wrapper">
        <div class="projects">
            <router-link style="text-decoration:none" :to="project.data.link" v-for="project in projects"
                :key="project.id" class="projects__entity active"
                @mouseover="handleProjectSelection($event, project, 'enter')">

                <!-- <pre style="color: white"> {{ project }} </pre> -->
                
                <div class="entity__image" :style="`background: url(${resolveImageURL(project)})`">
                    <img :src="resolveLogoURL(project)" />
                </div>

                <div class="entity__info">
                    <div class="entity__headline active">

                        <h3>{{ project.data.title }}</h3>

                    </div>
                    <div class="entity__subheadline">
                        <div class="subheadline__animated">
                            {{ project.data.subtitle }}
                        </div>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'

    import imageAnalyzer from '../../utilities/image-analyzer'

    export default {
        data() {
            return {
                activeImage: '../../assets/img/testtexture.webp',
                projects: [],
                lastSelected: null
            }
        },
        // computed: {
        //     ...mapState([
        //         'projects'
        //     ])
        // },
        created() {
            this.getProjects();
        },
        methods: {
            getProjects() {
                this.$prismic.client.query(
                        this.$prismic.Predicates.at('document.type', 'projects'),
                    )
                    .then((document) => {
                        let projects = document.results

                        // Filter the projects where project.release is 'portfolio-2023'
                        const filteredProjects = projects.filter(project => project.data.release ===
                            'portfolio-2023');

                        // Sort the projects by their id
                        const sortedProjects = filteredProjects.sort((a, b) => {
                            return a.data.id - b.data.id;
                        });


                        this.projects = sortedProjects

                        projects.forEach((project) => {
                            const imageURL = project.data.preview[0].preview1.url
                            this.imageLoader.push(imageURL)
                        })

                        console.log(this.imageLoader)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            resolveImageURL(project) {
                return project.data.preview[0].background.url
            },
            resolveLogoURL(project) {
                return project.data.preview[0].logo.url
            },
            analyzeImage(url) {
                let result = this.getImageBrightness(url)
                console.log(result)
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/base.scss';

    .projects-wrapper {
        display: flex;
        height: auto;
        align-items: center;
    }

    .projects {
        display: flex;
        position: relative;
        flex-direction: column;
        width: 100%;
        max-width: 100rem;
        margin: 0 auto;
        padding: 5rem 1rem;

        .projects__entity {
            position: relative;
            display: flex;
            flex-direction: column !important;
            align-items: start;
            text-decoration: none;
            width: 100%;
            border-radius: 8px;
            font-family: "Franziska Italic";
            background-size: cover !important;
            margin: .5rem 0;
            box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.09);
            border: 0.5px solid rgba(255, 255, 255, 0.25);
        }

        .entity {
            cursor: pointer;

            &__info {
                background: linear-gradient(to right, var(--primaryColor), var(--secondaryColor));
            }

            &__headline {
                position: relative;
                left: .25rem;
                right: .25rem;
                padding: .5rem 1rem .22rem .75rem;
                margin: .5rem 0;
                color: $light;

                a,
                h3 {
                    font-size: 1.25rem;
                    font-family: 'Inter';
                    color: $light;
                    text-decoration: none;
                    margin: 0;
                }
            }

            &__subheadline {
                position: relative;
                bottom: .25rem;
                left: .25rem;
                right: .25rem;
                color: $light;
                text-decoration: none;
                padding: 0rem 1rem .75rem .75rem;
            }


            &__image {
                height: 100%;
                padding: 1rem;
                background-size: contain;
                border-top-left-radius: 8px;
                border-top-right-radius: 8px;
            }
        }
    }
</style>